import { useDispatch } from 'react-redux';
import { User } from '@rossum/api-client/users';
import { useDeleteUser } from '../../../../business/users/useDeleteUser';
import { signOut } from '../../../../redux/modules/auth/actions';
import { throwInfo } from '../../../../redux/modules/messages/actions';
import { GroupRole } from '../../../../types/group';
import { getUserName } from '../../helpers';
import { DeleteUserDialogWithCheckboxes } from './DeleteUserDialogWithCheckboxes';
import { DeleteUserDialogWithoutCheckboxes } from './DeleteUserDialogWithoutCheckboxes';
import {
  canRemoveUser,
  isModeWithCheckboxes,
  useDeleteUserMode,
} from './helpers';

type Props = {
  onDelete?: () => void;
  onCancel: () => void;
  user: User;
  role: GroupRole | undefined;
};

export const DeleteUserDialog = ({ onDelete, onCancel, user, role }: Props) => {
  const mode = useDeleteUserMode({ user, role });

  const { mutate: deleteUser } = useDeleteUser();

  const dispatch = useDispatch();

  if (mode === 'loading') {
    return null;
  }

  return isModeWithCheckboxes(mode) ? (
    <DeleteUserDialogWithCheckboxes
      onDelete={() =>
        deleteUser({
          userId: user.id,
          onSuccess: () => {
            onDelete?.();
            dispatch(signOut({ handled: true }));
            dispatch(
              throwInfo(
                mode === 'delete_organization'
                  ? 'organizationDeleted'
                  : 'userDeleted',
                { user: getUserName(user) }
              )
            );
          },
        })
      }
      onCancel={onCancel}
      user={user}
      deletingOrganization={mode === 'delete_organization'}
    />
  ) : (
    <DeleteUserDialogWithoutCheckboxes
      onDelete={() =>
        deleteUser({
          userId: user.id,
          onSuccess: () => {
            onDelete?.();
            dispatch(throwInfo('userDeleted', { user: getUserName(user) }));
          },
        })
      }
      onCancel={onCancel}
      user={user}
      {...canRemoveUser(mode)}
    />
  );
};
